import * as React from 'react'

/**
 * Mouth with an arrow pointing away from it: scan taken WITHOUT the device/appliance.
 *
 * Counterpart of WithAligners/WithoutAligners for patients on a practice-set double scan,
 * who wear a retainer or elastic bands. Shows a mouth and a direction with no appliance
 * drawn, so it reads for whatever the practice prescribed.
 *
 * The design exports this in white because it sits on a dark scan thumbnail there; the
 * colour is a prop so it also works on the white scan-feed toggle, matching the default
 * used by the aligner icons it stands in for.
 */
export default ({ color = '#3C52EF', width = '30', height = '21' }) => (
  <svg width={width} height={height} viewBox="0 0 36 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.375 5.73092C0.375 4.24006 1.28574 2.9005 2.67212 2.35222L5.23968 1.3368C7.29497 0.523973 9.6362 0.998497 11.2128 2.54744L11.275 2.60855L11.3372 2.54744C12.9138 0.998497 15.255 0.523974 17.3103 1.3368L19.8779 2.35222C21.2643 2.9005 22.175 4.24006 22.175 5.73092V13.3222C22.175 19.3421 17.2949 24.2222 11.275 24.2222C5.2551 24.2222 0.375 19.3421 0.375 13.3222V5.73092Z"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M22.175 6.14873V10.341C22.175 16.3609 17.2949 21.241 11.275 21.241C5.2551 21.241 0.375 16.3609 0.375 10.341V6.14873"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M2.42456 16.7693L4.29998 15.9006C5.95821 15.1326 7.81515 14.9026 9.61066 15.2428L11.275 15.5581L12.9393 15.2428C14.7348 14.9026 16.5918 15.1326 18.25 15.9006L20.1254 16.7693"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M10.9 18.2132C10.9 18.4204 11.0679 18.5882 11.275 18.5882C11.4821 18.5882 11.65 18.4204 11.65 18.2132H10.9ZM10.9 15.5581V18.2132H11.65V15.5581H10.9Z"
      fill={color}
    />
    <path
      d="M0.561279 5.31027C0.561279 5.31027 7.07522 4.37865 11.275 4.37865C15.4747 4.37865 21.9886 5.31027 21.9886 5.31027"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M6.52368 4.65811V8.47777C6.52368 9.14665 7.06591 9.68888 7.73479 9.68888H10.0639C10.7327 9.68888 11.275 9.14665 11.275 8.47777V4.27431"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M11.275 4.27431V8.47777C11.275 9.14665 11.8173 9.68888 12.4861 9.68888H14.8152C15.4841 9.68888 16.0263 9.14665 16.0263 8.47777V4.65811"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M16.0264 4.65811V7.54615C16.0264 8.21503 16.5686 8.75726 17.2375 8.75726H18.8212C19.4901 8.75726 20.0324 8.21503 20.0324 7.54615V5.58974"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M20.0322 5.12393V7.08034C20.0322 7.74922 20.5745 8.29145 21.2433 8.29145H22.0352"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M2.51782 5.58974V7.54615C2.51782 8.21503 3.06006 8.75726 3.72893 8.75726H5.31269C5.98157 8.75726 6.52381 8.21502 6.52381 7.54615V4.65811"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M2.51776 5.12393V7.08034C2.51776 7.74922 1.97553 8.29145 1.30665 8.29145H0.514771"
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M34.783 11.61H25.6676M32.0004 14.3926L34.783 11.61L32.0004 8.82747"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
